// import React from "react";
import { libraries } from "./registry";

export function Renderer({ schema, theme, font, renderEditable }) {
  const { category, variant, editableData } = schema;
  const lib = libraries?.[category];
  const item = lib?.[variant];

  if (!item) return <div>Component not found</div>;

  const Comp = item.Component;

  return (
    <Comp
      theme={theme}
      font={font}
      editableData={editableData}
      renderEditable={renderEditable}
    />
  );
}
